import * as zod from 'zod'

export function validate<T extends zod.ZodTypeAny>(schema: T, data: unknown): string | null {
  const result = schema.safeParse(data)

  if (!result.success) {
    const error = result.error.format()
    return error._errors[0]
  }

  return null
}
